import React, { useState, useEffect } from 'react';
import '../../css/onboardingFirstSteps.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CustomButton from '../../components/CustomButton';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId, setAcceptUserTerms } from '../../features/onboardingData/onboardingUserData';
import { useMobileMediaQuery, useTabletMediaQuery, useUltraMobileMediaQuery } from '../../utils';
import Form from 'react-bootstrap/Form';
import { AiOutlineStop } from "react-icons/ai";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { errorHandling } from '../../utils';
import { GTM } from '../../components/GTM/GTM';

function OnboardingStepFour({ mainImgSvg, onPrev }) {

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isUltraMobile = useUltraMobileMediaQuery();
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isAcceptUserTerms = useSelector((state) => state.onboardingUserData.isAcceptUserTerms);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isChecked3, setIsChecked3] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [errorAlert, setErrorAlert] = useState('');

    useEffect(() => {
        const delay = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(delay);
    }, []);

    const handleStartUsing = () => {
        navigate('/ativar-carteira-virtual');
    };

    const fetchCSRFToken = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
                credentials: "include",
                mode: 'cors'
            });
            const data = await response.json();
            const csrfToken = data.csrfToken;

            return csrfToken;
        } catch (error) {
            errorHandling('CSRF');
        }
    };

    const getRegistarCliente = async () => {
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/registarCliente/fetchRegistarCliente`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    'ClientId': '',
                    "xsrf-token": csrfToken,
                },
                credentials: "include",
                mode: "cors",
                body: JSON.stringify({ umbrellaId: isCookieId }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                dispatch(setAcceptUserTerms(true));
                handleStartUsing();
            } else {
                const errorMessages = result.error.errorStatus.map(status => status.erroMsg);
                const errorMessageString = errorMessages.join(', ');
                setErrorAlert(errorMessageString)
                setModalShow(true)
            }
        } catch (error) {
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    return (
        <>
            <GTM />
            <Header />
            {!isTablet &&
                <>
                    <div className='mainBgViewContainerStepsStackMobileTablet'></div>
                </>
            }
            <div className={isTablet ? 'mainViewContainerStepsStack' : (isMobile ? 'mainViewContainerStepsStackTablet' : 'mainViewContainerStepsStackMobile')}>
                {!isTablet &&
                    <>
                        <div className={isMobile ? 'mainImgViewStepsStackTablet' : 'mainImgViewStepsStackMobile'}>
                            <img src={mainImgSvg} alt="imagem" className={isMobile ? "mainImgStepsStackTablet" : (isUltraMobile ? "mainImgStepsStackPreMobile" : "mainImgStepsStackMobile")} />
                        </div>
                    </>
                }
                <div className={isTablet ? 'firstTxtViewContainerStepsStack' : (isMobile ? 'firstTxtViewContainerStepsStackTablet' : 'firstTxtViewContainerStepsStackMobile')}>
                    <div className='firstTitleViewStepsStack'>
                        <span className={isTablet ? 'textTitlePart2StepsStack' : (isMobile ? 'textTitlePart1StepsStackTablet' : 'textTitlePart1StepsStackMobile')}>Sem mais passos</span>
                        <span className={isTablet ? 'textTitlePart1StepsStack' : (isMobile ? 'textTitlePart2StepsStackTablet' : 'textTitlePart2StepsStackMobile')}> nem burocracias</span>
                        <span className={isTablet ? 'textTitlePart3StepsStack' : (isMobile ? 'textTitlePart2StepsStackTablet' : 'textTitlePart2StepsStackMobile')}>.</span>
                    </div>
                    <div className={isTablet ? 'secondTitleViewStepsStack' : (isMobile ? 'secondTitleViewStepsStackTablet' : 'secondTitleViewStepsStackMobile')}>É só começar a acumular!</div>
                    <div className={isTablet ? 'secondSmallTitleViewStepsStack' : (isMobile ? 'secondSmallTitleViewStepsStackTablet' : 'secondSmallTitleViewStepsStackMobile')}>Acompanhe o seu histórico: quanto acumulou em cada compra, em que parceiros e como gastou o saldo.</div>
                    <div className='checkboxBtnGoViewStepsStack'>
                        <Form className='checkboxFormViewStepsStack'>
                            <div className='firstOptionsFormChekedViewStepsStack'>
                                <div className='firstOptionsRowFormChekedViewStepsStack'>
                                    <Form.Check
                                        type="checkbox"
                                        label={''}
                                        checked={isChecked3}
                                        onChange={() => setIsChecked3(!isChecked3)}
                                    />
                                    <div className='txtFormStepsStack' onClick={() => setIsChecked3(!isChecked3)} style={{ cursor: 'pointer' }}>
                                        <span className='txtFormStepsStack'>Li e aceito os </span>
                                        <a href="https://saude360.medis.pt/informacao-legal/" target="_blank" rel="noopener noreferrer" className="linkStepsStack">
                                            <span className='txtFormForTermsOfConditionsStepsStack' >Termos e Condições</span>
                                        </a>
                                        <span className='txtFormStepsStack'> da Carteira Virtual Médis.</span>
                                    </div>
                                </div>
                            </div>
                        </Form>
                        {modalShow &&
                            <div className='txtViewErrorInfoStepsStack'>
                                <div className='txtErrorInfoStepsStack'><AiOutlineStop className='iconErrorInfoStepsStack' /> {errorAlert}</div>
                            </div>
                        }
                        <div className={isTablet ? 'btnsViewStepsStack' : (isMobile ? 'btnsViewStepsStackTablet' : 'btnsViewStepsStackMobile')}>
                            <div className={isTablet ? 'divBtnNextStepsStack' : (isMobile ? 'divBtnSaltarStepsStackTablet' : 'divBtnNextStepsStackMobile')}>
                                <CustomButton
                                    text={'Começar a usar'}
                                    textColor={'#00214D'}
                                    onPress={getRegistarCliente}
                                    color={'#15D4B6'}
                                    enabled={isChecked3}
                                    hasArrow
                                    iconColor={'#00214D'}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        isTablet ? null : (isMobile ? (
                            <>
                                <div className='cirlceSelectedViewStepsStackMobile'>
                                    <div className='cirlceSelectedStepsStackMobile'>
                                        <div className='circleMainvViewStepsStack'>
                                            <button className='iconArrowLeftViewStepsStack' onClick={() => onPrev()}>
                                                <FaArrowLeftLong className='iconArrowStepsStack' />
                                            </button>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleSelectedViewStepsStack' />
                                            </div>
                                            <button className='iconArrowRightViewStepsStack' disabled>
                                                <FaArrowRightLong className='iconArrowStepsStack' />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) :
                            <>
                                <div className='cirlceSelectedViewStepsStackMobile'>
                                    <div className='cirlceSelectedStepsStackMobile'>
                                        <div className='circleMainvViewStepsStack'>
                                            <button className='iconArrowLeftViewStepsStack' onClick={() => onPrev()}>
                                                <FaArrowLeftLong className='iconArrowStepsStack' />
                                            </button>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleSelectedViewStepsStack' />
                                            </div>
                                            <button className='iconArrowRightViewStepsStack' disabled>
                                                <FaArrowRightLong className='iconArrowStepsStack' />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
                {isTablet &&
                    <>
                        <div className='subFirstImgViewContainerStepsStack'>
                            <div className='firstImgViewContainerStepsStack'>
                                <div className='mainImgViewStepsStack'>
                                    <img src={mainImgSvg} alt="imagem" className="mainImgStepsStack" />
                                </div>
                                <div className='cirlceSelectedStepsStack'>
                                    <div className='circleMainvViewStepsStack'>
                                        <button className='iconArrowLeftViewStepsStack' onClick={() => onPrev()}>
                                            <FaArrowLeftLong className='iconArrowStepsStack' />
                                        </button>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleViewStepsStack' />
                                        </div>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleViewStepsStack' />
                                        </div>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleViewStepsStack' />
                                        </div>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleSelectedViewStepsStack' />
                                        </div>
                                        <button className='iconArrowRightViewStepsStack' disabled>
                                            <FaArrowRightLong className='iconArrowStepsStack' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            <Footer />
        </>
    )
}

export default OnboardingStepFour;